import { makeStyles, Typography, Button, Box } from '@material-ui/core';
import { Refresh as RefreshIcon, ErrorOutline as ErrorIcon } from '@material-ui/icons';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: theme.spacing(3),
  },
  contentWrapper: {
    maxWidth: 500,
    textAlign: 'center',
    padding: theme.spacing(6, 4),
  },
  iconWrapper: {
    display: 'inline-flex',
    padding: theme.spacing(3),
    borderRadius: '50%',
  },
  errorIcon: {
    fontSize: 64,
    color: '#dc2626',
    filter: 'drop-shadow(0 4px 6px rgba(220, 38, 38, 0.1))',
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  description: {
    fontSize: '1rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
    lineHeight: 1.6,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      marginBottom: theme.spacing(3),
    },
  },
  refreshButton: {
    textTransform: 'none',
    borderRadius: 12,
    padding: theme.spacing(1.5, 4),
    fontSize: '1rem',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #5B65DC 0%, #0088CC 100%)',
    color: '#ffffff',
    boxShadow: '0 4px 12px rgba(0, 168, 255, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #0088CC 0%, #0066AA 100%)',
      boxShadow: '0 6px 20px rgba(0, 168, 255, 0.4)',
      transform: 'translateY(-2px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 3),
      fontSize: '0.875rem',
    },
  },
  refreshIcon: {
    marginRight: theme.spacing(1),
    fontSize: 20,
  },
  decorativeElement: {
    position: 'absolute',
    width: 200,
    height: 200,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, rgba(0, 168, 255, 0.05) 0%, rgba(0, 168, 255, 0.02) 100%)',
    filter: 'blur(40px)',
    zIndex: -1,
  },
  decorativeTop: {
    top: -50,
    right: -50,
  },
  decorativeBottom: {
    bottom: -50,
    left: -50,
  },
}));

const MetadataErrorWidget = ({ onRefresh }) => {
  const classes = useStyles();
  const { en: { errors } } = useSelector((state) => state.i18n);

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.contentWrapper} position="relative">
        <Box className={`${classes.decorativeElement} ${classes.decorativeTop}`} />
        <Box className={`${classes.decorativeElement} ${classes.decorativeBottom}`} />

        <Box className={classes.iconWrapper}>
          <ErrorIcon className={classes.errorIcon} />
        </Box>

        <Typography className={classes.title}>
          {errors.metadataLoadingError}
        </Typography>

        <Typography className={classes.description}>
          {errors.metadataLoadingErrorDescription}
        </Typography>

        <Button
          variant="contained"
          className={classes.refreshButton}
          onClick={handleRefresh}
          startIcon={<RefreshIcon className={classes.refreshIcon} />}
        >
          {errors.refreshPage}
        </Button>
      </Box>
    </Box>
  );
};

export default MetadataErrorWidget;
